import Vue from 'vue'
// echarts
import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts;

class QiisChart {
  constructor(Arr) {
    let [id, option] = Arr;
    this.id = id;
    this.option = option;
    this.myChart = echarts.init(document.getElementById(this.id));
    this.setOption(this.option);
    this.resize();
    this.primitiveOption = option; // 原始 option
  }

  // 存储原始 option
  init(option) {
    console.log("🚀 ~ option:", option);
    this.primitiveOption = JSON.parse(JSON.stringify(option));
  }

  // 创建 / 更新 echarts 图例
  setOption(option) {
    this.myChart.clear();
    this.myChart.setOption(option, true);
  }

  // 自定义 echarts 图例
  custom(className) {
    if (!this.option) return
    this.option.grid.left = '30%';
    this.myChart.setOption(this.option, true);
    return this.option
  }

  // 恢复 echarts 图例
  recover() {
    this.setOption(this.primitiveOption);
  }

  // resize 监听 echarts 图例大小
  resize() {
    window.addEventListener('resize', () => {
      // 必须使用 addEventListener 注册新的监听事件，不能使用 window.onresize
      this.myChart.resize();
    });
  }
}
export {
  QiisChart
}